import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit,SimpleChanges } from '@angular/core';
import { NavController } from '@ionic/angular';

import { Booking } from '../../models';
import { Client } from '../../models';
import { ClientService } from '../../services/client.service';
import { List } from 'immutable';
import { Router } from '@angular/router';
import { AllowedStatus } from 'src/app/enums/bookingstatus';
@Component({
  selector: 'smr-client-bookings',
  templateUrl: 'client-bookings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ClientBookingsComponent implements OnInit, OnChanges {

  @Input() client: Client;

  public bookingList: List<Booking>;

  public isLoading: boolean;

  public errorOccurredWhileLoadingBookings: boolean;
  public allowedStatus: AllowedStatus[] = [
    AllowedStatus.Completed,
    AllowedStatus.ConfirmedByEmail,
    AllowedStatus.ConfirmedByEmailText,
    AllowedStatus.ConfirmedByPhone,
    AllowedStatus.ConfirmedByText,
    AllowedStatus.Deleted,
    AllowedStatus.NoShow,
    AllowedStatus.Paid,
    AllowedStatus.Requested,
    AllowedStatus.Unconfirmed,
  ];


  constructor(private navCtrl: NavController,
    private clientService: ClientService,
    private changeDetectorRef: ChangeDetectorRef,
    private route: Router) {
    this.bookingList = List.of<Booking>();
    this.isLoading = true;
  }

  public ngOnInit() {
    this.loadBookings();
  }

  public isCancelled(status: number): boolean {
    return status === 6;
  }

  public ngOnChanges (changes: SimpleChanges) {
    if(changes.client){
      this.loadBookings();
    }
  }

  public loadBookings () {    
    this.isLoading = true;
    this.errorOccurredWhileLoadingBookings = false;
    this.clientService.getClientBookings(this.client.getID(),this.allowedStatus)

      .subscribe({
        next: (bookings: List<Booking>) => {
          this.isLoading = false;
          this.bookingList = bookings;
          this.changeDetectorRef.markForCheck();
        },
        error: (err) => {
          this.isLoading = false;
          this.errorOccurredWhileLoadingBookings = true;
          this.changeDetectorRef.markForCheck();
        }
      });
  }

  public onBookingView(booking: Booking) {
    //this.navCtrl.push("BookingFormSummaryPage", {bookingID: booking.getId()});
    if (booking.status != 6) {
      this.route.navigate(["/bookings/booking-form-summary", booking.getId()])
    }
  }
}
